var _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeChoiceImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 287,
    viewBox: "0 0 229 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 125.5,
    rx: 134,
    ry: 125.5,
    fill: "#13184F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.5,
    cy: 187,
    rx: 106.5,
    ry: 100,
    fill: "#FF7527"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.169 214.915V178.21L120.041 162.684L96.2596 178.699V214.916H94.9123C92.6892 214.916 90.8709 216.734 90.8709 218.957V223H166.559V218.957C166.559 216.734 164.74 214.916 162.517 214.916L161.169 214.915ZM169.302 178.72L119.728 160.007L87.3273 181.827L86 179.844L119.421 157.339L170.143 176.486L169.302 178.72L169.302 178.72ZM102.41 151H110.788V160.269L102.41 165.91V151ZM112.193 214.915V188.669H131.993V214.915H112.193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChoiceImg);
export default __webpack_public_path__ + "static/media/HomeChoiceImg.952c947463bc9a837f55864a27c59068.svg";
export { ForwardRef as ReactComponent };